import {
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT,
  REFRESH_TOKEN_SUCCESS,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD_ERROR,
  SET_TOKEN,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERR,
  RESET_CHANGE_PASSWORD_STATE

} from "../utils/constants";
import jwt_decode from "jwt-decode";
import { USER_KEY, TOKEN_KEY, REFRESH_TOKEN_KEY, role } from "../utils/define";

// Khôi phục token từ localStorage khi khởi tạo state
const getInitialToken = () => {
  try {
    const storedToken = localStorage.getItem(TOKEN_KEY);
    if (storedToken) {
      console.log("StoreAuth - Khôi phục token từ localStorage");
      return storedToken;
    }
  } catch (error) {
    console.error("StoreAuth - Lỗi khi đọc token từ localStorage:", error);
  }
  return null;
};

export const authState = {
  error: false,
  errorContent: "",
  token: getInitialToken(), // Khôi phục token từ localStorage
  codeStatusForgotPass: 0,
  detailErrorForgotPas: null,
  codeStatusResetPass: 0,
  detailErrorResetPas: null,
  codeStatusChangePass: 0,
  detailErrorChangePass: null,
};

export function authReducer(state, action) {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case LOGIN_SUCCESS:
      if (action.payload.accessToken && action.payload.refreshToken) {
        let user = jwt_decode(action.payload.accessToken);
        localStorage.setItem(USER_KEY, JSON.stringify(user));
        // localStorage.setItem(
        //   TOKEN_KEY,
        //   JSON.stringify(action.payload.accessToken)
        // );
         localStorage.setItem(
          TOKEN_KEY,
          action.payload.accessToken
        );
        localStorage.setItem(
          REFRESH_TOKEN_KEY,
          action.payload.refreshToken
        );
        console.log("LOGIN_SUCCESS reducer - localStorage saved successfully");
      } else {
        console.warn("LOGIN_SUCCESS reducer - SKIPPED localStorage save because accessToken or refreshToken is missing!");
      }

      return {
        ...state,
        token: action.payload.accessToken,
        error: false,
        errorContent: "",
      };

    case LOGIN_ERROR:
      let errors = action.payload;
      if (errors.Username) {
        return {
          ...state,
          token: null,
          error: true,
          errorContent: errors.Username[0],
        };
      }
      if (errors.Password) {
        return {
          ...state,
          token: null,
          error: true,
          errorContent: errors.Password[0],
        };
      }
      return {
        ...state,
        token: null,
        error: true,
        errorContent: errors.content[0],
      };

    case REFRESH_TOKEN_SUCCESS:
      localStorage.setItem(
        USER_KEY,
        // JSON.stringify(jwt_decode(action.payload.accessToken))
        jwt_decode(action.payload.accessToken)
      );
      localStorage.setItem(
        TOKEN_KEY,
        action.payload.accessToken
      );
      localStorage.setItem(
        REFRESH_TOKEN_KEY,
        action.payload.refreshToken
      );
      return {
        ...state,
        token: action.payload.accessToken,
        error: false,
        errorContent: "",
      };
    case LOGOUT:
      localStorage.clear();
      return { ...state, token: null, error: false, errorContent: "" };
    case FORGOT_PASSWORD:
      return { ...state, codeStatusForgotPass: action.payload };
    case FORGOT_PASSWORD_ERROR:
      return { ...state, detailErrorForgotPas: action.payload };
    case RESET_PASSWORD_ERROR:
      return { ...state, detailErrorResetPas: action.payload };
    case RESET_PASSWORD:
      return { ...state, codeStatusResetPass: action.payload };
    case CHANGE_PASSWORD_ERR:
      return { ...state, detailErrorChangePass: action.payload };
    case CHANGE_PASSWORD:
      return { ...state, codeStatusChangePass: action.payload };
    case SET_TOKEN:
      return { ...state, token: action.payload };
    case RESET_CHANGE_PASSWORD_STATE:
      return {
        ...state,
        codeStatusChangePass: 0,
        detailErrorChangePass: null,
      };
    default:
      return state;
  }
}
